export { default as Quote } from './Quote';